import {useMutation, useQueryClient} from 'react-query';
import CustomerPortalAPI, {DocusignEnvelope, Requirement} from '../../../APIs/CustomerPortalAPI';

type DocusignEnvelopeForRequirementMutationInput = Requirement & {
    dsReturnUrl: string;
};

export function useDocusignEnvelopeForRequirementMutation() {
    const queryClient = useQueryClient();

    return useMutation<DocusignEnvelope, Error, DocusignEnvelopeForRequirementMutationInput>(
        // Remove dataJson from the input in order
        // to force a new docusign envelope to be created
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        async ({dataJson, customerId, ...input}) => {
            const envelope = await CustomerPortalAPI.UpdateUnderwritingRequirements({
                customerId,
                newRequirements: [input],
            });

            if (!envelope) {
                throw new Error('Failed to update underwriting requirements');
            }

            return envelope;
        },
        {
            onSuccess: (_data, input) => {
                // We invalidate policies because we are querying requirements from policies
                queryClient.invalidateQueries(['policies', {customerId: input.customerId}]);
            },
        },
    );
}
